const parseUri = require('parse-uri');
const PACKAGE_NAME = 'localizationUtils';

/**
 * This function returns boolean value whether localization is needed or not
 * @param url Absolute/relative url to be localized. Relative url must starts with '/'.
 * @param parsedUrl parsed url
 * @param siteContext(basePath,hostname) Site context information, including basePath and hostname.
 * @returns boolean
 */
// eslint-disable-next-line complexity
const islocalizationRequired = (url, siteContext = {}) => {
    if (!url || !siteContext) {
        return false;
    }

    const parsedUrl = parseUri(url);
    /** return if current site hostName doesn't match with url hostname **/
    if (parsedUrl.host && siteContext.hostname !== parsedUrl.host) {
        return false;
    }
    return true;
};

/**
 * This function returns string value
 * @param url Absolute/relative url to be localized. Relative url must starts with '/'.
 * @param parsedUrl parsed url
 * @param siteContext(basePath,hostname) Site context information, including basePath and hostname.
 * @param path localized path.
 * @param queryParam exists in case of auth urls
 * @returns string
 */
const buildUrl = (url, parsedUrl, siteContext = {}, path, queryParam) => {
    let host = parsedUrl.authority || siteContext.hostname;

    if (!host) {
        throw new Error(`[${PACKAGE_NAME}] Error: Hostname missing.`);
    }

    let scheme = parsedUrl.protocol || 'https';
    if (queryParam) {
        return `${scheme}://${host}${parsedUrl.path}?${queryParam}`;
    }
    return `${scheme}://${host}${path}`;
};

/**
 * This function just validates base path and logs if base path is missing
 * @param siteContext
 * @returns {boolean} for now it always return true and just logs if basePath is missing
 */
const validateSiteContextBasePath = (siteContext) => {
    if (typeof siteContext.basePath !== 'string') {
        console.warn(`[${PACKAGE_NAME}] BasePath missing.`); // eslint-disable-line
    }
    return true;
};

module.exports = {
    buildUrl,
    islocalizationRequired,
    validateSiteContextBasePath
};
